import { Caption } from 'ui/theme';
import { ProjectCell, ProjectName, Cell } from './UsagePages.styled';
import { ORG_ROW_NAME, PROJECT_NAME_COLUMN_VALUE } from '../../constants';
import { Link } from 'ui/links';

type CellProps = {
  isOrgRow: boolean;
  row: any;
  colValue: string;
};

const Name = ({ projectName, href }: { href?: string; projectName: string }) => {
  return href ? (
    <Link href={href} useReactRouter>
      {projectName}
    </Link>
  ) : (
    <span>{projectName}</span>
  );
};

export const TableCell = ({ isOrgRow, row, colValue }: CellProps) =>
  colValue === PROJECT_NAME_COLUMN_VALUE ? (
    <ProjectCell isOrg={isOrgRow}>
      <ProjectName>
        {isOrgRow ? ORG_ROW_NAME : <Name href={row?.href} projectName={row.projectName} />}
      </ProjectName>
      {/* projectId is set to '' in case of an Organization metric */}
      {row.projectId && <Caption>ID {row.projectId}</Caption>}
    </ProjectCell>
  ) : (
    <Cell isOrg={isOrgRow}>{row[colValue]?.toLocaleString()}</Cell>
  );

export const createRowCell =
  (colValue: string) =>
  ({
    row,
  }: {
    row: Record<string, string | number>;
  }) => <TableCell isOrgRow={!row.projectId} row={row} colValue={colValue} />;
